<template>
  <div style="width: 100vw;height: 100vh;background: black;position:relative;">
    <div :style="{pointerEvents: enableMapInteract ? 'auto' : 'none'}" id="map"></div>
    <GrowthMarkerEntry v-if="growthAnalysisShow && chooseBtn === '影像信息' && introductionJsonList.length !== 0" :map="map" :marker-list="introductionJsonList"></GrowthMarkerEntry>
    <div v-if="chooseBtn === '商品信息' && !fromSourceResult" style="position: absolute;left: 50%;top: 50%;background: rgba(0,0,0,0.3);width: 148px;height: 26px;border-radius: 13px;display: flex;align-items: center;">
      <div class="mid-center" style="width: 15px;height: 15px;background: rgba(255,255,255,0.2);border-radius: 50%;margin-left: 7px;margin-right: 7px;">
        <div style="width: 9px;height: 9px;background: rgba(255,255,255,1);border-radius: 50%"></div>
      </div>
      <div style="font-size: 12px;color: white;">点击可查看地块信息</div>
    </div>
    <!--    热力条-->
    <div v-if="growthAnalysisShow && chooseBtn === '影像信息' && landImageCardInfo.length > 0 && landImageCardInfo[growthImageIndex].analysisLayer.length !== 0" style="position: absolute;left: 34px;top: 15%">
      <div class="mid-center heat-bar-text">旺</div>
      <div class="heat-bar" :style="{background: heatBarStyle}"></div>
      <div class="mid-center heat-bar-text">弱</div>
    </div>
    <!--    底部按钮和卡片区域-->
    <div class="bottom-area">
      <!--    类别切换按钮区域-->
      <div style="display: flex;align-items: center;">
        <div @click="changeBtnType('商品信息')" class="type-btn"
             :style="{backgroundColor: chooseBtn === '商品信息' ? fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(105, 94, 193, 1)' : 'white', color: chooseBtn === '商品信息' ? 'white' : 'rgba(128, 128, 128, 1)'}">
          商品信息
        </div>
        <div @click="changeBtnType('地块信息')" class="type-btn"
             :style="{backgroundColor: chooseBtn === '地块信息' ? fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(105, 94, 193, 1)' : 'white', color: chooseBtn === '地块信息' ? 'white' : 'rgba(128, 128, 128, 1)'}">
          地块信息
        </div>
        <div @click="changeBtnType('影像信息')" class="type-btn"
             :style="{backgroundColor: chooseBtn === '影像信息' ? fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(105, 94, 193, 1)' : 'white', color: chooseBtn === '影像信息' ? 'white' : 'rgba(128, 128, 128, 1)'}">
          影像信息
        </div>
      </div>
      <!--    内容卡片区域-->
      <div class="content-area">
        <div v-if="chooseBtn === '商品信息' && productCardInfo" class="price-info-card">
          <img style="width: 110px;height: 110px;border-radius: 10px;" :src="productCardInfo.picture">
          <div class="product-card-content">
            <div class="one-line-clamp"
                 style="font-family: AlimamaShuHeiTi;font-size: 14px;color: black;width: calc(100vw - 170px);">
              {{ productCardInfo.name }}
            </div>
            <div style="display: flex;align-items: center;margin-top: 5px;">
              <div class="iconfontFamily" style="font-size: 8px;color: rgba(0, 0, 0, 0.5);margin-top: 2px;">&#xe7cc;
              </div>
              <div class="iconfontFamily one-line-clamp"
                   style="margin-left: 4px;font-family: AlimamaShuHeiTi;font-size: 10px;color: rgba(0, 0, 0, 0.7)">
                {{ productCardInfo.plantPosition }}
              </div>
            </div>
            <div class="two-line-clamp" style="margin-top: 9px;font-size: 10px;color: rgba(56, 56, 56, 0.9);">
              {{ productCardInfo.introduce }}
            </div>
            <div class="spacer"></div>
            <div style="display: flex;align-items: center;">
              <div style="color: rgba(255, 141, 26, 1);font-size: 18px;font-family: AlibabaPuHuiTi;font-weight: 500">
                ￥{{ productCardInfo.price }}
              </div>
              <div class="spacer"></div>
              <div @click="buyProduct" class="click-button"
                   :style="{backgroundColor: fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(105, 94, 193, 1)'}"
                   style="margin-right: 6px;">立即购买</div>
            </div>
          </div>
        </div>
        <div v-if="chooseBtn === '地块信息' && landCardInfo" style="width: calc(100vw - 36px);height: 100%;padding-left: 12px;">
          <div class="land-card-content" style="padding-top: 14px;">
            <div style="width: 80%">
              <div class="one-line-clamp"
                   style="font-family: AlimamaShuHeiTi;font-size: 14px;color: black;margin-left: 5px;">
                溯源地块：{{ landCardInfo.code }}
              </div>
            </div>
            <!-- 移除margin-top，使用父容器的padding-top控制间距 -->
            <div style="width: calc(100vw - 74px);border-radius: 9px;padding: 10px 8px 10px 18px;background: rgba(204, 204, 204, 0.4);display: flex;align-items: center;margin-top: 12px;">
              <div>
                <div class="one-line-clamp land-info-text" style="height: 17px;">
                  地块面积：{{ landCardInfo.areaInfo }}亩
                </div>
                <div class="one-line-clamp land-info-text" style="margin-top: 4px;height: 17px;">
                  种植作物：{{ productCardInfo.plant }}
                </div>
                <div class="one-line-clamp land-info-text" style="margin-top: 4px;height: 17px;">
                  种植主体：{{ landCardInfo.plantCompany.companyName }}
                </div>
                <div class="one-line-clamp land-info-text" style="margin-top: 4px;height: 17px;">
                  地块位置：{{ landCardInfo.geoName }}
                </div>
              </div>
              <div class="spacer"></div>
              <div>
                <div @click="intoMoreInfo"
                     class="click-button"
                     :style="{background: fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(105, 94, 193, 1)'}"
                     >更多信息
                </div>
                <div @click="intoLandSupervise"
                     :style="{background: fromMiniProgram ? 'rgba(242, 252, 217, 0.8)' : 'rgba(252, 253, 255, 0.8)', color: fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(105, 94, 193, 1)'}"
                     style="margin-top: 8px;"
                     class="click-button">地块监督</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="chooseBtn === '影像信息'">
          <div style="display: flex;align-items: center;padding-left: 19px;padding-right: 19px;padding-top: 14px;">
            <div style="font-family: AlimamaShuHeiTi;font-size: 14px;color: black;height: 17px;">作物生长卫星影像</div>
            <div class="spacer"></div>
            <label v-if="landImageCardInfo[growthImageIndex].analysisLayer.length !== 0" class="switch">
              <input type="checkbox" v-model="growthAnalysisShow">
              <span class="slider round"></span>
            </label>
            <div v-if="landImageCardInfo[growthImageIndex].analysisLayer.length !== 0" style="font-family: AlibabaPuHuiTi;font-size: 12px;color: rgba(56,56,56,1);margin-left: 7px;">
              长势分析
            </div>
          </div>
          <div
              style="display: flex;align-items: center;margin-top: 12px;width: calc(100vw - 24px);overflow-x: auto;white-space: nowrap;flex-wrap: nowrap;padding-bottom: 8px;">
            <div style="width: 13px;flex-shrink: 0;"></div>
            <div id="landScrollArea" @click="changeLandImage(index)" v-for="(item, index) in landImageCardInfo" :key="index"
                 class="land-image-card"
                 :style="{background: growthImageIndex === index ? fromMiniProgram ? 'rgba(110, 189, 8, 1)' : 'rgba(131, 122, 201, 1)' : 'rgba(204, 204, 204, 1)'}">
              <div class="one-line-clamp land-card-text" style="margin-top: 4px;font-size: 14px;">{{ item.opreation }}</div>
              <div class="one-line-clamp land-card-text">{{ item.shootTimeStr }}</div>
            </div>
            <div style="width: 13px;flex-shrink: 0;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getMapboxToken} from "@/utils/utils";
import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";
import GrowthMarkerEntry from "@/views/TraceSource/GrowthMarkerEntry.vue";

export default {
  name: 'TraceSourcePage',
  components: {GrowthMarkerEntry},
  watch: {
    growthAnalysisShow(val) {
      const layerId = 'growth-analysis'
      if (val) {
        this.map.setLayoutProperty(layerId, 'visibility', 'visible')
      } else {
        // 隐藏长势图层
        this.map.setLayoutProperty(layerId, 'visibility', 'none')
      }
    }
  },
  data() {
    return {
      map: '',
      chooseBtn: '商品信息',  // 商品信息 地块信息 影像信息
      image: 'https://market.obs.cn-north-4.myhuaweicloud.com:443/202604071536000138724.png',
      currLandId: '',
      currGeoFeature: '',
      growthAnalysisShow: true,
      productCardInfo: '',
      landCardInfo: '',
      landImageCardInfo: '',
      growthImageIndex: 0,
      isFirstCall: true,
      fromSourceResult: false,
      heatBarStyle: '',
      tbProductId: '',
      jdProductId: '',
      introductionJsonList: [],
      enableMapInteract: true,
      fromMiniProgram: false,
    }
  },
  methods: {
    async initMap() {
      await getMapboxToken()
      mapboxgl.accessToken = this.globalJS.mapboxToken;
      this.map = new mapboxgl.Map({
        container: 'map',
        center: [0, 0],
        zoom: 15,
        minZoom: 15,
        maxZoom: 17,
        style: this.globalJS.mapboxStyle,
        preserveDrawingBuffer: true,
        localIdeographFontFamily: '',
        projection: {name: 'globe'},
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) {
            return {
              url: url.replace('https://api.mapbox.com', 'https://earth.jl1.cn/mapbox'),
            };
          }
        }
      })
      this.map.on('load', () => {
        this.map.addSource('china1m2021', {
          type: 'raster',
          tiles: [
            // this.globalJS.world1mUrl_2021
            this.globalJS.world1mUrl_2021
          ],
          tileSize: 256,
          scheme: 'tms',
        });
        this.map.addLayer({
          id: 'china1mLayer',
          type: 'raster',
          source: 'china1m2021',
        })
        // 从气泡进入,参数有productId，没有landId
        // 从扫码进入，参数有productId和landId
        if (!this.fromSourceResult) {
          this.$http.get('/earthApi/t-product/getTProductLandById?productId=' + this.$route.query.productId).then((resp) => {
            resp = resp.data
            if (resp.status === 200) {
              this.addDashLineLayers(resp.data.featureCollection.features)
              // 根据defaultLandId获取具体的详情
              this.getLandDetailById(resp.data.defaultLand, this.$route.query.productId)
            }
          })
        } else {
          this.getLandDetailById(this.$route.query.landId, this.$route.query.productId)
        }
        this.map.addSource('road', {
          type: 'raster',
          tiles: [
            'https://t0.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=05861044e5fe4135647facbd39abc543'
          ],
          tileSize: 256,
        });
        this.map.addLayer({
          id: 'roadLayer',
          type: 'raster',
          source: 'road'
        })
      })
    },
    setHeatBarStyle(colors) {
      if (colors.length === 0) {
        this.heatBarStyle = `transparent`
        return
      }
      let styleStr = ''
      for (let i = 0; i < colors.length; i++) {
        let percentage = i / (colors.length - 1) * 100
        styleStr += `${colors[i]} ${percentage}%${i !== colors.length - 1 ? ',' : ''}`
      }
      this.heatBarStyle = `linear-gradient(180deg, ${styleStr})`
    },
    // 根据id获取地块信息详情，用于点击geo获取数据
    getLandDetailById(landId, productId) {
      this.$http.get('/earthApi/t-land/getDetailByLandId?landId=' + landId + '&productId=' + productId).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.productCardInfo = resp.data.product
          if (window['flutter_setTopBarName']) {
            window['flutter_setTopBarName'].postMessage(this.productCardInfo.title)
          }
          this.landCardInfo = resp.data.land
          this.landImageCardInfo = resp.data.landImages
          this.tbProductId = this.productCardInfo.tbLink
          this.jdProductId = this.productCardInfo.jdLink
          const geo = JSON.parse(this.landCardInfo.geo)
          this.currGeoFeature = geo
          // 首次进入直接fitBounds，其余的有2s过渡效果
          this.mapFitBounds(this.currGeoFeature, this.isFirstCall ? 1 : 500)
          this.isFirstCall = false
          if (this.fromSourceResult) {
            this.addDashLineLayers([geo])
            this.changeBtnType('地块信息')
          }
          this.addLandHighLightLayer(geo)
          // 影像信息是必须先点击按钮通过changeBtnType()修改图层显隐度后，再点击geo进行切换，下面的代码指的是点击geo切换流程
          if (this.currLandId !== landId) {
            this.growthImageIndex = 0
            if (this.landImageCardInfo.length > 0) {
              this.setHeatBarStyle(this.landImageCardInfo[0]['colors'])
            }
            this.addGrowthImageLayer()
          }
          this.currLandId = landId
          // this.changeBtnType('地块信息')
        }
      })
    },
    // 添加影像信息 + 长势分析热力图
    addGrowthImageLayer() {
      const growImageLayerId = 'growth-image'
      if (this.map.getSource(growImageLayerId)) {
        this.map.removeLayer(growImageLayerId)
        this.map.removeSource(growImageLayerId)
      }
      this.map.addSource(growImageLayerId, {
        type: 'raster',
        tiles: [
          this.landImageCardInfo[this.growthImageIndex].layer
        ],
        tileSize: 256,
        scheme: 'tms'
      })
      this.map.addLayer({
        id: growImageLayerId,
        type: 'raster',
        source: growImageLayerId,
        layout: {
          visibility: this.chooseBtn !== '影像信息' ? 'none' : 'visible'
        }
      }, 'fill-layer-0')

      const growAnalysisLayerId = 'growth-analysis'
      if (this.map.getSource(growAnalysisLayerId)) {
        this.map.removeLayer(growAnalysisLayerId)
        this.map.removeSource(growAnalysisLayerId)
      }
      this.introductionJsonList = []
      setTimeout(() => {
        this.introductionJsonList = this.landImageCardInfo[this.growthImageIndex].introduceJson
      }, 50)
      if (this.landImageCardInfo[this.growthImageIndex].analysisLayer.length !== 0) {
        this.map.addSource(growAnalysisLayerId, {
          type: 'raster',
          tiles: [
            this.landImageCardInfo[this.growthImageIndex].analysisLayer
          ],
          tileSize: 256,
          scheme: 'tms'
        })
        this.map.addLayer({
          id: growAnalysisLayerId,
          type: 'raster',
          source: growAnalysisLayerId,
          layout: {
            visibility: (this.chooseBtn === '影像信息' && this.growthAnalysisShow) ? 'visible' : 'none'
          }
        }, 'fill-layer-0')
      }

    },
    // 添加地块高亮geo图层
    addLandHighLightLayer(geo) {
      // 添加高亮图层
      const highlightSource = 'highlight'
      const fillLayerId = 'highlight-fill'
      const borderLayerId = 'highlight-border'
      if (this.map.getSource(highlightSource)) {
        this.map.removeLayer(fillLayerId)
        this.map.removeLayer(borderLayerId)
        this.map.removeSource(highlightSource)
      }
      // 添加数据源
      this.map.addSource(highlightSource, {
        type: 'geojson',
        data: geo
      })
      // 添加图层
      this.map.addLayer({
        id: fillLayerId,
        type: 'fill',
        source: highlightSource,
        paint: {
          'fill-color': 'rgba(255, 141, 26, 0.0)',
          'fill-opacity': 1,
          'fill-outline-color': 'transparent',
        },
        layout: {
          visibility: this.chooseBtn === '地块信息' ? 'visible' : 'none' // 刚进来时 不显示高亮
        }
      })
      // 添加虚线边框图层
      this.map.addLayer({
        id: borderLayerId,
        type: 'line',
        source: highlightSource,
        // visibility: 'none',
        paint: {
          'line-color': 'rgba(255, 0, 0, 1)',
          'line-width': 2,
          'line-opacity': 1,
          'line-dasharray': [2, 2]  // 虚线样式
        },
        layout: {
          visibility: this.chooseBtn === '地块信息' ? 'visible' : 'none'
        }
      })
      console.log(`添加了图层${JSON.stringify(geo)}`)
    },
    mapFitBounds(feature, duration = 500) {
      const bbox = turf.bbox(feature)
      this.map.setMinZoom(1)
      this.enableMapInteract = false
      this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
        linear: false,
        zoom: 15,
        animate: true,
        padding: {left: 20, right: 20, top: 20, bottom: 20},
        duration: duration,
        easing: (t) => {
          if (t === 1) {
            this.map.setMinZoom(15)
            this.enableMapInteract = true
          }
          return t
        }
      })
    },
    changeBtnType(type) {
      if (type === '商品信息') {
        if (this.map.getSource('highlight')) {
          this.map.setLayoutProperty('highlight-fill', 'visibility', 'none')
          this.map.setLayoutProperty('highlight-border', 'visibility', 'none')
        }
        if (this.map.getSource('growth-image')) {
          this.map.setLayoutProperty('growth-image', 'visibility', 'none')
        }
        if (this.map.getSource('growth-analysis')) {
          this.map.setLayoutProperty('growth-analysis', 'visibility', 'none')
        }
        if (this.map.getSource('road')) {
          this.map.setLayoutProperty('roadLayer', 'visibility', 'visible')
        }
      } else if (type === '地块信息') {
        if (this.map.getSource('highlight')) {
          this.map.setLayoutProperty('highlight-fill', 'visibility', 'visible')
          this.map.setLayoutProperty('highlight-border', 'visibility', 'visible')
        }
        if (this.map.getSource('growth-image')) {
          this.map.setLayoutProperty('growth-image', 'visibility', 'none')
        }
        if (this.map.getSource('growth-analysis')) {
          this.map.setLayoutProperty('growth-analysis', 'visibility', 'none')
        }
        if (this.map.getSource('road')) {
          this.map.setLayoutProperty('roadLayer', 'visibility', 'visible')
        }
        this.mapFitBounds(this.currGeoFeature)
      } else {
        if (this.map.getSource('highlight')) {
          this.map.setLayoutProperty('highlight-fill', 'visibility', 'none')
          this.map.setLayoutProperty('highlight-border', 'visibility', 'none')
        }
        if (this.map.getSource('growth-image')) {
          this.map.setLayoutProperty('growth-image', 'visibility', 'visible')
        }
        this.growthAnalysisShow = true
        if (this.map.getSource('growth-analysis')) {
          this.map.setLayoutProperty('growth-analysis', 'visibility', this.growthAnalysisShow ? 'visible' : 'none')
        }
        if (this.map.getSource('road')) {
          this.map.setLayoutProperty('roadLayer', 'visibility', 'none')
        }
        this.mapFitBounds(this.currGeoFeature)
      }
      this.chooseBtn = type
    },
    // 点击不同的影像切换
    changeLandImage(index) {
      this.mapFitBounds(this.currGeoFeature)
      if (this.growthImageIndex === index) {
        return
      }
      this.growthAnalysisShow = true
      this.setHeatBarStyle(this.landImageCardInfo[index]['colors'])
      this.growthImageIndex = index
      this.addGrowthImageLayer()
    },
    addDashLineLayers(featureList) {
      for (let i = 0; i < featureList.length; i++) {
        const feature = featureList[i]
        const sourceId = `source-${i}`
        const fillLayerId = `fill-layer-${i}`
        const borderLayerId = `border-layer-${i}`

        // 添加数据源
        this.map.addSource(sourceId, {
          type: 'geojson',
          data: feature
        })

        // 添加填充图层
        this.map.addLayer({
          id: fillLayerId,
          type: 'fill',
          source: sourceId,
          paint: {
            'fill-color': this.fromSourceResult ? 'rgba(255, 141, 26, 0.0)' : 'rgba(255, 255, 255, 0.0)',  // 填充颜色
            'fill-opacity': 1,  // 填充透明度
            'fill-outline-color': 'transparent'
          }
        })

        // 给图层添加点击事件
        this.map.on('click', fillLayerId, () => {
          if (this.chooseBtn === '商品信息') {
            this.chooseBtn = '地块信息'
          }
          // todo: 颜色会叠加变深
          if (this.fromSourceResult) {
            this.mapFitBounds(this.currGeoFeature, this.isFirstCall ? 1 : 500)
            this.changeBtnType('地块信息')
          } else {
            this.getLandDetailById(feature.properties.landId, this.$route.query.productId)
          }
        })

        // 添加虚线边框图层
        this.map.addLayer({
          id: borderLayerId,
          type: 'line',
          source: sourceId,
          paint: {
            'line-color': 'rgba(255, 255, 255, 1)',  // 白色边框
            'line-width': 2,  // 1px宽度
            'line-opacity': 1,  // 完全不透明
            'line-dasharray': [2, 2]  // 虚线样式
          }
        })
      }
    },
    intoMoreInfo() {
      if(this.$route.query.miniProgram) {
        // eslint-disable-next-line no-undef
        if (typeof wx !== 'undefined' && wx.miniProgram){
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({url: '/pages/detail_info/detailInfo?productId=' + this.$route.query.productId + '&landId=' + this.currLandId})
        }
      }else{
        if (window['flutter_traceSourceIntoMoreInfo']) {
          window['flutter_traceSourceIntoMoreInfo'].postMessage(JSON.stringify({
            productId: this.$route.query.productId,
            landId: this.currLandId
          }))
        }
      }
    },
    intoLandSupervise() {
      if(this.$route.query.miniProgram){
        // eslint-disable-next-line no-undef
        if (typeof wx !== 'undefined' && wx.miniProgram){
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({url: '/pages/land_mass_supervision/landMassSupervision?mainId=' + this.currLandId + '&landCode=' + this.landCardInfo.code})
        }
      }else{
        if (window['flutter_traceSourceLandSupervise']) {
          window['flutter_traceSourceLandSupervise'].postMessage(JSON.stringify({
            landId: this.currLandId,
            landCode: this.landCardInfo.code
          }))
        }
      }

    },
    buyProduct() {
      let productId = this.jdProductId.length !== 0 ? this.jdProductId : this.tbProductId
      if(this.$route.query.miniProgram){
        // 小程序
        // eslint-disable-next-line no-undef
        if (typeof wx !== 'undefined' && wx.miniProgram){
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({url: '/pages/buy_page/buyPage?productId=' + this.$route.query.productId  + '&landId=' + this.currLandId})
        }
      }else {
        if (window['flutter_traceSourceBuyProduct']) {
          window['flutter_traceSourceBuyProduct'].postMessage(JSON.stringify({
            productId: productId,
            platform: this.jdProductId.length !== 0 ? 'jd' : 'tb'
          }))
        }
      }
    },
  },
  mounted() {
    this.initMap()
    this.fromSourceResult = this.$route.query.landId !== '' && this.$route.query.landId !== undefined
    this.fromMiniProgram = this.$route.query.miniProgram !== '' && this.$route.query.miniProgram !== undefined
  }
}
</script>

<style scoped>
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.mid-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.heat-bar {
  width: 15px;
  height: 245px;
  border: 1px solid white;
  //background: linear-gradient(180deg, rgba(250, 35, 6, 1) 0%, rgba(250, 83, 4, 1) 17.06%, rgba(255, 130, 1, 1) 37.3%, rgba(254, 228, 7, 1) 55.86%, rgba(223, 236, 9, 1) 71.03%, rgba(113, 162, 3, 1) 82.14%, rgba(1, 98, 3, 1) 100%);
}

.heat-bar-text {
  width: 17px;
  height: 17px;
  background: white;
  color: black;
  font-size: 10px;
  font-family: AlibabaPuHuiTi;
}

.bottom-area {
  position: absolute;
  bottom: 44px;
  width: calc(100vw - 24px);
  margin-left: 12px;
  margin-right: 12px;
}

.type-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 69px;
  height: 27px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 10px;
  margin-left: 7px;
  font-family: AlimamaShuHeiTi
}

.price-info-card, .land-info-card {
  display: flex;
  align-items: center;
  width: calc(100vw - 36px);
  height: 100%;
  padding-left: 12px;
}

.land-info-text {
  //margin-top: 4px;
  font-size: 12px;
  width: calc(100vw - 200px);
  color: rgba(56, 56, 56, 0.9);
}

.content-area {
  height: 157px;
  width: 100%;
  background: white;
  margin-top: 12px;
  border-radius: 20px;
}

.spacer {
  flex: 1 1 auto;
}

.product-card-content {
  //background: red;
  width: calc(100vw - 170px);
  margin-left: 13px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 35px);
  margin-top: 13px;
  margin-bottom: 22px;
}

.land-card-content {
  //background: red;
  width: calc(100vw - 56px);
  display: flex;
  flex-direction: column;
  height: calc(100% - 28px);
  //margin-top: 12px;
  //margin-bottom: 16px;
}

.one-line-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.two-line-clamp {
  display: -webkit-box; /* 弹性盒子模型 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 2; /* 限制显示行数 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  word-break: break-all; /* 允许单词内断行 */
  word-wrap: break-word; /* 允许长单词换行 */
  line-height: 1.5; /* 合适的行高 */
}

.click-button {
  width: 95px;
  height: 27px;
  background: rgba(105, 94, 193, 1);
  border-radius: 10px;
  color: white;
  font-family: AlimamaShuHeiTi;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  cursor: pointer;
}


/* 开关 - 滑块周围的框 */
.switch {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 12px;
}

/* 隐藏默认 HTML 复选框 */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* 滑块 */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .2s;
  transition: .2s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 1px;
  bottom: 1px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(8px);
  -ms-transform: translateX(8px);
  transform: translateX(8px);
}

/* 圆角滑块 */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#landScrollArea {
  /* 隐藏所有浏览器的滚动条但保持可滚动 */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

#landScrollArea::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.land-image-card {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-shrink: 0;
  //width: 86px;
  width: calc((100vw - 70px) / 4);
  height: 100px;
  border-radius: 10px;
  margin-left: 3px;
  margin-right: 3px;
}

.land-card-text {
  font-size: 10px;
  color: white;
  font-weight: 500;
  max-width: 60px;
  margin-top: 4px;
}
</style>